import { useState, useEffect } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Hook para buscar todos os agregados mensais de transações em tempo real
 * Reduz drasticamente leituras do Firebase e atualiza automaticamente
 */
export const useTransactionsAggregate = () => {
  const [transactions, setTransactions] = useState([]);
  const [availableYears, setAvailableYears] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    // Listener em tempo real para a coleção de agregados
    const transactionsAggregatesCollection = collection(db, 'agregadoTransacoes');
    
    const unsubscribe = onSnapshot(
      transactionsAggregatesCollection,
      (aggregatesSnapshot) => {
        try {
          const allTransactions = [];
          const yearsSet = new Set();
          
          aggregatesSnapshot.forEach((doc) => {
            const data = doc.data();
            const transactionsArray = data.transacoes || [];
            
            // Extrair o ano do documento (do campo ano ou do ID)
            let year = null;
            if (data.ano) {
              year = data.ano;
            } else {
              // Tentar extrair do ID (formato: YYYY-MM)
              const docId = doc.id;
              const match = docId.match(/^(\d{4})-\d{2}$/);
              if (match) {
                year = parseInt(match[1]);
              }
            }
            
            // Se tem transações, adicionar o ano
            if (year && transactionsArray.length > 0) {
              yearsSet.add(year);
            }
            
            // Adicionar todas as transações deste mês ao array geral
            transactionsArray.forEach((transaction) => {
              allTransactions.push({
                ...transaction,
                data: transaction.data?.toDate ? transaction.data.toDate() : new Date(transaction.data),
                // Campos de compatibilidade para código existente (apenas leitura)
                date: transaction.data?.toDate ? transaction.data.toDate() : new Date(transaction.data),
                amount: transaction.valor,
                description: transaction.descricao,
                appointmentId: transaction.idAgendamento
              });
            });
          });
          
          // Ordenar todas as transações por data (mais recente primeiro)
          allTransactions.sort((a, b) => {
            const dateA = a.data instanceof Date ? a.data : new Date(a.data);
            const dateB = b.data instanceof Date ? b.data : new Date(b.data);
            return dateB.getTime() - dateA.getTime();
          });
          
          // Ordenar anos (mais recente primeiro)
          const yearsArray = Array.from(yearsSet).sort((a, b) => b - a);
          
          setTransactions(allTransactions);
          setAvailableYears(yearsArray);
          setLoading(false);
        } catch (err) {
          setError(err);
          setLoading(false);
        }
      },
      (err) => {
        // Callback de erro do onSnapshot
        setError(err);
        setLoading(false);
      }
    );

    // Cleanup: remover listener quando o componente desmontar
    return () => {
      unsubscribe();
    };
  }, []);

  return { transactions, availableYears, loading, error };
};




